// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Atom_Cta from "../design-system/atom/Atom_Cta.bs.js";
import * as GlobalStyle from "../design-system/GlobalStyle.bs.js";
import * as Provider_I18n from "../provider/Provider_I18n.bs.js";
import * as User_Provider from "../user/User_Provider.bs.js";
import * as Corporate_Menu from "./Corporate/Corporate_Menu.bs.js";
import * as Organism_Footer from "../design-system/organism/footer/Organism_Footer.bs.js";
import * as Organism_Header from "../design-system/organism/header/Organism_Header.bs.js";
import * as Provider_Config from "../provider/Provider_Config.bs.js";
import * as Organism_Carousel_Corporate from "../design-system/organism/carousel/Organism_Carousel_Corporate.bs.js";

Provider_I18n.make.displayName = "I18nProvider";

Provider_Config.make.displayName = "ConfigProvider";

User_Provider.make.displayName = "UserProvider";

function globalStyle(withFont) {
  GlobalStyle.make(withFont, "Dark", true, undefined);
}

Organism_Header.make.displayName = "Header";

Organism_Footer.make.displayName = "Footer";

Organism_Carousel_Corporate.make.displayName = "Carousel";

var Button = Atom_Cta.Corporate.make;

Button.displayName = "Button";

Corporate_Menu.make.displayName = "Menu";

var I18nProvider = Provider_I18n.make;

var ConfigProvider = Provider_Config.make;

var UserProvider = User_Provider.make;

var Header = Organism_Header.make;

var Footer = Organism_Footer.make;

var Carousel = Organism_Carousel_Corporate.make;

var Menu = Corporate_Menu.make;

export {
  I18nProvider ,
  ConfigProvider ,
  UserProvider ,
  globalStyle ,
  Header ,
  Footer ,
  Carousel ,
  Button ,
  Menu ,
}
/*  Not a pure module */
